import { render, staticRenderFns } from "./ListHeader.vue?vue&type=template&id=038e8c3d&scoped=true&"
import script from "./ListHeader.vue?vue&type=script&lang=js&"
export * from "./ListHeader.vue?vue&type=script&lang=js&"
import style0 from "./ListHeader.vue?vue&type=style&index=0&id=038e8c3d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038e8c3d",
  null
  
)

export default component.exports